import styled from "@emotion/styled";
import * as React from "react";
import { FieldRenderProps } from "react-final-form";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon/Icon";
import { withVar } from "themes/helpers";

import { fieldErrorCss } from "./styled";

const LockIcon = styled(Icon)`
  position: absolute;
  right: 10px;
  bottom: 13px;
  fill: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor60
  };
`;

interface IStyledInputContainerProps {
  display: string;
}

const StyledInputContainer = styled.span<IStyledInputContainerProps>`
  position: relative;
  display: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.display || "inline-block"
  };

  input {
    line-height: 18px;
    border-radius: 4px;
    border: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
    padding: 10px;
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.primaryColor80
    };
    max-width: 100%;
    box-sizing: border-box;
    transition: border 0.25s ease-in-out;
    will-change: border-color;

    &:disabled {
      padding-right: 30px;
    }

    &:focus {
      outline: none;
      border-color: ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.activeBorderColor
      };
    }
  }

  span.field-error {
    ${fieldErrorCss};
  }
`;

interface IProps extends ICustomTextInputProps {
  error?: string;
}

export interface ICustomTextInputProps {
  display?: string;
  fieldRef?(ref: HTMLInputElement): void;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
}

export const TextInput: React.FC<IProps> = ({
  className,
  display,
  disabled,
  fieldRef,
  placeholder,
  error,
  ...props
}) => (
  // @ts-expect-error TS(2332)
  <StyledInputContainer className={className} display={display}>
    <input type="text" ref={fieldRef} disabled={disabled} placeholder={placeholder} {...props} />
    {disabled && <LockIcon name={IconsEnum.ClosedLock} width="16px" height="16px" />}
    {error && <span className="field-error">{error}</span>}
  </StyledInputContainer>
);

export const TextInputFinalForm: React.FC<FieldRenderProps<string, HTMLElement> & ICustomTextInputProps> = ({
  input,
  meta,
  ...props
}) => <TextInput error={meta && meta.submitFailed && meta.error} {...input} {...props} />;
